import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { LicenseInfo } from '@mui/x-license-pro';

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_DATAGRID_PRO);

ReactDOM.render(
  // <React.StrictMode>
  <App />,
  /* </React.StrictMode> */
  document.getElementById('root')
);
